import React, { useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Button,
    ButtonGroup,
} from "reactstrap";
import BasicModal from '../../../../components/Modals/BasicModal'
import { titleCase } from '../../../../utils/views/pages/Dynamics'
import classnames from "classnames";

const CouponInformation = (props) => {
    const coupon = props.coupon
    const formDisabled = props.formDisabled
    const setCoupon = props.setCoupon
    const [showModal, setShowModal] = useState(false)
    const [warning, setWarning] = useState("")
    const [radios, setRadios] = useState(0)
    const validations = props.validations

    let validateField = (e) => {
        if (!e.target.value.trim() && e.target.required) {

            setWarning('The field \'' + titleCase(e.target.name) + '\' is required!')
            setShowModal(true)

        } else {
            if (validations[e.target.name] && !validations[e.target.name].test(e.target.value)) {
                setWarning('Invalid ' + titleCase(e.target.name))
                setShowModal(true)
            }
        }

    }

    let handleInput = (e) => {

        coupon[e.target.name] = e.target.value
        setCoupon(coupon)

    }

    return (
        <>
            <h6 className="heading-small text-muted mb-4">
                Coupon information
            </h6>
            <div className="pl-lg-4">
                <Row>
                    <Col lg="4">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-code"
                            >
                                Code
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={coupon?.code}
                                id="input-code"
                                name="code"
                                placeholder="Coupon Code"
                                type="text"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="4">
                        <label
                            className="form-control-label"
                            htmlFor="input-absolute"
                        >
                            Type
                        </label> <br/>
                        <ButtonGroup className="btn-group-toggle" data-toggle="buttons">

                            <Button id="input-absolute" 
                                disabled={formDisabled}
                                className={classnames({ active: radios === 0 })} 
                                color="secondary" onClick={() => {setRadios(0); coupon['isPercentage']=false; setCoupon(coupon);}}>
                                <input
                                    autoComplete="off"
                                    name="absolute"
                                    type="radio"
                                    value={radios === 0}
                                />
                                Absolute Value
                            </Button>
                            <Button id="input-percentage" 
                                disabled={formDisabled}
                                className={classnames({ active: radios === 1 })} 
                                color="secondary" onClick={() => {setRadios(1); coupon['isPercentage']=true;setCoupon(coupon);}}>
                                <input
                                    autoComplete="off"
                                    name="percentage"
                                    type="radio"
                                    value={radios === 1}                                    
                                />
                                Percentage
                            </Button>
                        </ButtonGroup>
                    </Col>
                    <Col lg="4">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-value"
                            >
                                Value
                            </label>

                            <InputGroup id="input-group" className="input-group-alternative ">

                                <InputGroupAddon addonType="prepend" className=''>
                                    <InputGroupText >
                                        {radios==0?(<i className="fas fa-dollar-sign trailing"></i>): (<b>%</b>)}
                                    </InputGroupText>

                                    <Input
                                        className="form-control-alternative"
                                        id="input-value"
                                        defaultValue={coupon.value}
                                        type="number"
                                        step="0.01"
                                        disabled={formDisabled}
                                        placeholder="Coupon Value"
                                        name="value"
                                        onChange={handleInput}
                                        required={true}
                                        onBlur={validateField}
                                    />
                                </InputGroupAddon>

                            </InputGroup>

                        </FormGroup>
                    </Col>
                </Row>

            </div>

            <BasicModal
                title="Warning"
                message={warning}
                showModal={showModal}
                setShowModal={setShowModal} />
        </>
    )
}

export default CouponInformation;